import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getAllBySelector,
    getBySelector,
    getValueBySelector, hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {addTemporaryLayer} from "@/helpers/layer/temporary/temporary-layer-helper";
import {BookmarkDataSetFileComponent} from "@/components/bookmark/dataset/bookmark-data-set-file-component";
import {BookmarkDataSetWebserviceComponent} from "@/components/bookmark/dataset/bookmark-data-set-webservice-component";
import {RightMouseButtonComponent} from "@/components/bookmark/right-mouse-button-component";
import {
    BookmarkUserSessionStartButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-start-button-component";
import {
    BookmarkUserSessionUpdateButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-update-button-component";
import {
    BookmarkUserSessionShareButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-share-button-component";
import {
    BookmarkUserSessionRemoveButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-remove-button-component";
import {
    BookmarkUserSessionUpdateNameButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-update-name-button-component";
import {
    BookmarkUserSessionDefaultButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-default-button-component";
import {
    BookmarkUserSessionAddButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-add-button-component";


export class BookmarkSessionComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');


        template.innerHTML = ''

        initWebComponent(this, template)
    }
}


window.customElements.define("bookmark-user-session-start-button", BookmarkUserSessionStartButtonComponent);
window.customElements.define("bookmark-user-session-update-button", BookmarkUserSessionUpdateButtonComponent);
window.customElements.define("bookmark-user-session-share-button", BookmarkUserSessionShareButtonComponent);
window.customElements.define("bookmark-user-session-remove-button", BookmarkUserSessionRemoveButtonComponent);
window.customElements.define("bookmark-user-session-update-name-button", BookmarkUserSessionUpdateNameButtonComponent);
window.customElements.define("bookmark-user-session-default-button", BookmarkUserSessionDefaultButtonComponent);
window.customElements.define("bookmark-user-session-add-button", BookmarkUserSessionAddButtonComponent);
